import "url-polyfill";
import fromEntries from "object.fromentries";
import Vue from "vue";
import Vuex from "vuex";
import BootstrapVue from "bootstrap-vue";
import { VLazyImagePlugin } from "v-lazy-image";
import VueCarousel from "vue-carousel";
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
import { config } from "@fortawesome/fontawesome-svg-core";
import * as Sentry from "@sentry/browser";
import vClickOutside from "v-click-outside";
import { createUniqIdsMixin } from "vue-uniq-ids/dist/vue-uniq-ids.min";
import WebAccount from "spiritweb.packages.web-account";
import Ecommerce, { GtagPlugin } from "spiritweb.packages.ecommerce";
import LogRocket from "logrocket";
import iframeResize from "iframe-resizer/js/iframeResizer";

// Disable linting for next line as there may be a naming clash between
// vue-scrollto and vue-scrollTo, both libraries are the same, vue-scrollto
// is just a newer version
// eslint-disable-next-line import/no-unresolved
import VueScrollTo from "vue-scrollto";

import logrocket from "~/Scripts/config/logrocket";
import store from "~/Scripts/store";
import "~/Styles/components/breadcrumb.less";
import MiniBasket from "~/Components/Basket/MiniBasket.vue";
import MegaMenu from "~/Components/MegaMenu.vue";
import QuickSearch from "~/Components/Search/QuickSearch.vue";
import HtmlEmbed from "~/Components/Base/HtmlEmbed.vue";
import DefaultModal from "~/Components/Base/DefaultModal.vue";
import GlButton from "~/Components/Base/GlButton.vue";
import GlLink from "~/Components/Base/GlLink.vue";
import RegionSwitch from "~/Components/Base/RegionSwitch.vue";
import GeoTracking from "~/Components/GeoTracking.vue";
import SocialShare from "~/Components/Social/SocialShare.vue";

import "spiritweb.packages.ecommerce/dist/spiritweb.packages.ecommerce.min.css";
import "spiritweb.packages.web-account/dist/spiritweb.packages.web-account.min.css";

if ( !Object.fromEntries ) {
  // Add fromEntries polyfil
  fromEntries.shim();
}

config.autoReplaceSvg = false;
config.observeMutations = false;

logrocket.init();

Vue.directive( "resize", {
  bind ( el, { value = {} } ) {
    el.addEventListener( "load", () => iframeResize( value, el ) );
  },
  unbind ( el ) {
    el.iFrameResizer.removeListeners();
  },
} );

Vue.use( Vuex );
Vue.use( BootstrapVue );
Vue.use( VLazyImagePlugin );
Vue.use( VueCarousel );
Vue.use( vClickOutside );
Vue.use( WebAccount, { store } );
Vue.use( GtagPlugin );
Vue.use( VueScrollTo, {
  container: "#app",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
} );

Vue.use( Ecommerce, {
  sentry: { dsn: "https://efaf2caa441d41999fb5223e17504a46@o351484.ingest.sentry.io/5413420" },
} );

Vue.component( "font-awesome-icon", FontAwesomeIcon );
Vue.component( "font-awesome-layers", FontAwesomeLayers );
Vue.component( "mini-basket", MiniBasket );
Vue.component( "mega-menu", MegaMenu );
Vue.component( "quick-search", QuickSearch );
Vue.component( "html-embed", HtmlEmbed );
Vue.component( "default-modal", DefaultModal );
Vue.component( "gl-button", GlButton );
Vue.component( "gl-link", GlLink );
Vue.component( RegionSwitch.name, RegionSwitch );
Vue.component( GeoTracking.name, GeoTracking );
Vue.component( SocialShare.name, SocialShare );

const uniqIdsMixin = createUniqIdsMixin();
Vue.mixin( uniqIdsMixin );

const environment = document.querySelector( "meta[name=\"environment\"]" ).getAttribute( "content" );
Vue.prototype.$environment = environment;

const version = document.querySelector( "meta[name=\"version\"]" ).getAttribute( "content" );
Vue.prototype.$version = version;

const packageString = document.querySelector( "meta[name=\"package\"]" ).getAttribute( "content" );
Vue.prototype.$package = packageString;

const evdt = document.querySelector( "meta[name=\"evdt\"]" ).getAttribute( "content" ) === "true";
if ( evdt ) {
  Vue.config.devtools = true;
}

if ( process.env.NODE_ENV === "production" ) {
  LogRocket.getSessionURL( sessionURL => {
    Sentry.configureScope( scope => {
      scope.setExtra( "sessionURL", sessionURL );
    } );
  } );
}

const csrfToken = document.querySelector( "meta[name=\"csrf-token\"]" ).getAttribute( "content" );
Vue.prototype.$csrfToken = csrfToken;
